import ApiService from "@/core/services/ApiService";

class PayrollService {

    public static get(params) {
        ApiService.setHeader()
        return ApiService.get(`api/payroll/${params}`,'show')
    }

    //Buscar si existe 
    /*public static search(params) {
        ApiService.setHeader()
        return ApiService.post('api/payroll/search',params)
    }
    */

    /*public static save(params) {
        ApiService.setHeader()
        return ApiService.post('api/payroll/save',params)
    }
    */

    public static delete(id: string) {
        ApiService.setHeader()
        return ApiService.delete(`api/payroll/${id}`, 'delete')
    }

    public static update(id: string, params:any) {
        ApiService.setHeader()
        return ApiService.update(`api/payroll/${id}`, 'update', params)
    }

    public static getData(params) {
        ApiService.setHeader()
        return ApiService.post('api/payroll',params)
    }

    public static options(slug: string, params: any){
        ApiService.setHeader()
        return ApiService.post(`api/payroll/${slug}`, params)
    }

}

export default PayrollService;